import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import colors from "styles/colors";
import TitleLabel from "components/TitleLabel";
import GoogleAdsFormList from "components/gads/GoogleAdsFormList";
import googleSelectors from "modules/google/selectors";

const GoogleAdsSettingContent = ({ leadFormId, action }) => {
  const [t] = useTranslation();
  const businessInfoResult = useSelector((state) => googleSelectors.getBusinessInfoResult(state));
  const validateGoogleLeadFormResult = useSelector((state) => googleSelectors.setValidateGoogleLeadFormResult(state));
  const googleAdsLoading = useSelector((state) => googleSelectors.setGoogleAdsLoadingResult(state));

  const adsAccountRef = useRef(null);
  const [isAdsOverflowing, setIsAdsOverflowing] = useState(false);

  useEffect(() => {
    const textElement = adsAccountRef.current;

    if (textElement) {
      const isAdsOverflowing = textElement.scrollWidth > textElement.clientWidth;
      setIsAdsOverflowing(isAdsOverflowing);
    }
  }, [adsAccountRef]);

  const AdsAccountContainer = () => {
    return businessInfoResult.result === 0 ? (
      <AdsAccountBox isOverflowing={isAdsOverflowing}>
        <div>
          {businessInfoResult.data.adwords_name &&
          businessInfoResult.data.adwords_name !== "" &&
          businessInfoResult.data.adwords_name !== "-"
            ? businessInfoResult.data.adwords_name
            : t("__ads_label_google_ads_account")}
        </div>
        <div className="google-ads-id">{businessInfoResult.data.adwords_id}</div>
      </AdsAccountBox>
    ) : (
      "-"
    );
  };

  return (
    <>
      <TitleLabel title={t("__googleleads_google_ads_account")} required={false} />
      <AdsAccountContainer />
      <TitleLabel title={t("__googleleads_choose_form")} required={true} />
      {!googleAdsLoading.data.loading ? (
        <>
          <GoogleAdsFormList
            errorStatus={validateGoogleLeadFormResult.data.validateForm.result}
            action={action}
            leadFormId={leadFormId}
          />
          <>
            {validateGoogleLeadFormResult.data.validateForm.result &&
            validateGoogleLeadFormResult.data.validateForm.msg != "selected_form_have_used" ? (
              <TextWarning>{t("__select_form_warning")}</TextWarning>
            ) : (
              validateGoogleLeadFormResult.data.validateForm.result &&
              validateGoogleLeadFormResult.data.validateForm.msg == "selected_form_have_used" && (
                <TextWarning>{t("__selected_form_warning")}</TextWarning>
              )
            )}
          </>
        </>
      ) : (
        <LoadingArea>
          <StyledLoadingIcon />
        </LoadingArea>
      )}
    </>
  );
};

export default GoogleAdsSettingContent;

const AdsAccountBox = styled.div.attrs((props) => ({
  height: props.isOverflowing ? "fit-content" : "45px",
  whiteSpace: props.isOverflowing ? "wrap" : "nowrap",
}))`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
  color: #555;
  height: ${(props) => props.height};
  width: 100%;
  line-height: 1.5rem;
  .google-ads-name {
    width: 350px;
    line-height: 1.2rem;
    white-space: nowrap;
    white-space: ${(props) => props.whiteSpace};
  }
  .google-ads-id {
    font-size: 12px;
    color: #aaa;
  }
`;

const TextWarning = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  color: ${colors.negative};
  font-size: 12px;
  font-weight: normal;
  position: relative;
  line-height: 1rem;
`;

const LoadingArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  height: 100%;
`;

const StyledLoadingIcon = styled.div`
  border: 5px solid #ccc;
  border-top: 5px solid #eee;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: button-keyframe-spin 1s linear infinite;
  box-sizing: initial !important;
  position: sticky;

  @keyframes button-keyframe-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
